var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSignupDecorationLeft = function SvgSignupDecorationLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 77,
    viewBox: "0 0 61 77"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#333",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 22,
    x: 31.731,
    y: 6.932,
    rx: 3,
    transform: "rotate(-55 34.731 17.932)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 22,
    x: 19.098,
    y: 27.547,
    rx: 3,
    transform: "rotate(-88 22.098 38.547)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 24,
    x: 31.766,
    y: 48.068,
    rx: 3,
    transform: "rotate(-122 34.766 60.068)"
  }))));
};
export default SvgSignupDecorationLeft;